import React, { FC } from 'react';
import { classNames } from '../../utils';
import * as styles from './faIcons.module.css';

/**
 * Icon svg from https://fontawesome.com/icons
 */

interface IconProps {
  size?: number;
  className?: string;
}

export const Spinner: FC<IconProps> = ({ size = 1, className }) => (
  <svg
    className={classNames(styles.pulsingSpin, className)}
    style={{ display: 'inline-block', verticalAlign: `-${size / 8}em` }}
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}em`}
    viewBox="0 0 512 512"
    fill="currentColor"
  >
    <path d="M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z" />
  </svg>
);

export const CheckIcon: FC<IconProps> = ({ size = 1, className }) => (
  <svg
    className={className}
    style={{ display: 'inline-block', verticalAlign: `-${size / 8}em` }}
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}em`}
    viewBox="0 0 448 512"
    fill="currentColor"
  >
    <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z" />
  </svg>
);

export const SaveIcon: FC<IconProps> = ({ size = 1, className }) => (
  <svg
    className={className}
    style={{ display: 'inline-block', verticalAlign: `-${size / 8}em` }}
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}em`}
    viewBox="0 0 448 512"
    fill="currentColor"
  >
    <path d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" />
  </svg>
);

export const UndoIcon: FC<IconProps> = ({ size = 1, className }) => (
  <svg
    className={className}
    style={{ display: 'inline-block', verticalAlign: `-${size / 8}em` }}
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}em`}
    viewBox="0 0 512 512"
    fill="currentColor"
  >
    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z" />
  </svg>
);

export const RedoIcon: FC<IconProps> = ({ size = 1, className }) => (
  <svg
    className={className}
    style={{ display: 'inline-block', verticalAlign: `-${size / 8}em` }}
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}em`}
    viewBox="0 0 512 512"
    fill="currentColor"
  >
    <path d="M463.5 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5z" />
  </svg>
);

export const ObjectGroupIcon: FC<IconProps> = ({ size = 1, className }) => (
  <svg
    className={className}
    style={{ display: 'inline-block', verticalAlign: `-${size / 8}em` }}
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}em`}
    viewBox="0 0 576 512"
    fill="currentColor"
  >
    <path d="M32 119.4C12.9 108.4 0 87.7 0 64C0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32H456.6C467.6 12.9 488.3 0 512 0c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V392.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V119.4zM456.6 96H119.4c-5.6 9.7-13.7 17.8-23.4 23.4V392.6c9.7 5.6 17.8 13.7 23.4 23.4H456.6c5.6-9.7 13.7-17.8 23.4-23.4V119.4c-9.7-5.6-17.8-13.7-23.4-23.4zM128 160c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160zM256 320h32c35.3 0 64-28.7 64-64V224h64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V320z" />
  </svg>
);

export const CloneIcon: FC<IconProps> = ({ size = 1, className }) => (
  <svg
    className={className}
    style={{ display: 'inline-block', verticalAlign: `-${size / 8}em` }}
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}em`}
    viewBox="0 0 512 512"
    fill="currentColor"
  >
    <path d="M288 448H64V224h64V160H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V384H288v64zm-64-96H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64V288c0 35.3 28.7 64 64 64z" />
  </svg>
);

export const HandIcon: FC<IconProps> = ({ size = 1, className }) => (
  <svg
    className={className}
    style={{ display: 'inline-block', verticalAlign: `-${size / 8}em` }}
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}em`}
    viewBox="0 0 512 512"
    fill="currentColor"
  >
    <path d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V336c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L124.8 448c43.1 41.1 100.4 64 160 64H304c97.2 0 176-78.8 176-176V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V32z" />
  </svg>
);

export const ArrowCursorIcon: FC<IconProps> = ({ size = 1, className }) => (
  <svg
    className={className}
    style={{ display: 'inline-block', verticalAlign: `-${size / 8}em` }}
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}em`}
    viewBox="0 0 320 512"
    fill="currentColor"
  >
    <path d="M0 55.2V426c0 12.2 9.9 22 22 22c6.3 0 12.4-2.7 16.6-7.5L121.2 346l58.1 116.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9L179.8 320H297.9c12.2 0 22.1-9.9 22.1-22.1c0-6.3-2.7-12.3-7.4-16.5L38.6 37.9C34.3 34.1 28.9 32 23.2 32C10.4 32 0 42.4 0 55.2z" />
  </svg>
);

export const UserPlusIcon: FC<IconProps> = ({ size = 1, className }) => (
  <svg
    className={className}
    style={{ display: 'inline-block', verticalAlign: `-${size / 8}em` }}
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}em`}
    viewBox="0 0 640 512"
    fill="currentColor"
  >
    <path d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM504 312V248H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V136c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z" />
  </svg>
);

export const UserMinusIcon: FC<IconProps> = ({ size = 1, className }) => (
  <svg
    className={className}
    style={{ display: 'inline-block', verticalAlign: `-${size / 8}em` }}
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}em`}
    viewBox="0 0 640 512"
    fill="currentColor"
  >
    <path d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM472 200H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H472c-13.3 0-24-10.7-24-24s10.7-24 24-24z" />
  </svg>
);

export const FileImportIcon: FC<IconProps> = ({ size = 1, className }) => (
  <svg
    className={className}
    style={{ display: 'inline-block', verticalAlign: `-${size / 8}em` }}
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}em`}
    viewBox="0 0 512 512"
    fill="currentColor"
  >
    <path d="M128 64c0-35.3 28.7-64 64-64H352V128c0 17.7 14.3 32 32 32H512V448c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64V336H302.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H128V64zm0 224v48H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H128zM512 128H384V0L512 128z" />
  </svg>
);

export const ChairIcon: FC<IconProps> = ({ size = 1, className }) => (
  <svg
    className={className}
    style={{ display: 'inline-block', verticalAlign: `-${size / 8}em` }}
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}em`}
    viewBox="0 0 448 512"
    fill="currentColor"
  >
    <path d="M248 48V256h48V58.7c23.9 13.8 40 39.7 40 69.3V256h48V128C384 57.3 326.7 0 256 0H192C121.3 0 64 57.3 64 128V256h48V128c0-29.6 16.1-55.5 40-69.3V256h48V48h48zM48 288c-12.1 0-23.2 6.8-28.6 17.7l-16 32c-5 9.9-4.4 21.7 1.4 31.1S20.9 384 32 384l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32V384H352v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384c11.1 0 21.4-5.7 27.2-15.2s6.4-21.2 1.4-31.1l-16-32C423.2 294.8 412.1 288 400 288H48z" />
  </svg>
);

export const ArrowsAltHIcon: FC<IconProps> = ({ size = 1, className }) => (
  <svg
    className={className}
    style={{ display: 'inline-block', verticalAlign: `-${size / 8}em` }}
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}em`}
    viewBox="0 0 512 512"
    fill="currentColor"
  >
    <path d="M504.3 273.6c4.9-4.5 7.7-10.9 7.7-17.6s-2.8-13-7.7-17.6l-112-104c-7-6.5-17.2-8.2-25.9-4.4s-14.4 12.5-14.4 22l0 56-192 0 0-56c0-9.5-5.7-18.2-14.4-22s-18.9-2.1-25.9 4.4l-112 104C2.8 243 0 249.3 0 256s2.8 13 7.7 17.6l112 104c7 6.5 17.2 8.2 25.9 4.4s14.4-12.5 14.4-22l0-56 192 0 0 56c0 9.5 5.7 18.2 14.4 22s18.9 2.1 25.9-4.4l112-104z" />
  </svg>
);

export const ArrowsAltVIcon: FC<IconProps> = ({ size = 1, className }) => (
  <svg
    className={className}
    style={{ display: 'inline-block', verticalAlign: `-${size / 8}em` }}
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}em`}
    viewBox="0 0 512 512"
    fill="currentColor"
  >
    <path d="M145.6 7.7C141 2.8 134.7 0 128 0s-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9S14.5 160 24 160H80V352H24c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7s13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4H176V160h56c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112z" />
  </svg>
);

export const AlphaUpAZIcon: FC<IconProps> = ({ size = 1, className }) => (
  <svg
    className={className}
    style={{ display: 'inline-block', verticalAlign: `-${size / 8}em` }}
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}em`}
    viewBox="0 0 512 512"
    fill="currentColor"
  >
    <path d="M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L128 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 320c0 17.7 14.3 32 32 32h50.7l-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H429.3l73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H352c-17.7 0-32 14.3-32 32zM416 32c-12.1 0-23.2 6.8-28.6 17.7l-64 128-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3h88.4l7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-16-32-64-128C439.2 38.8 428.1 32 416 32zM395.8 176L416 135.6 436.2 176H395.8z" />
  </svg>
);

export const AlphaDownZAIcon: FC<IconProps> = ({ size = 1, className }) => (
  <svg
    className={className}
    style={{ display: 'inline-block', verticalAlign: `-${size / 8}em` }}
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}em`}
    viewBox="0 0 512 512"
    fill="currentColor"
  >
    <path d="M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L128 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 64c0-17.7 14.3-32 32-32H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L402.7 96H352c-17.7 0-32-14.3-32-32zm96 192c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L460.2 448H371.8l-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128c5.4-10.8 16.5-17.7 28.6-17.7zM395.8 400h40.4L416 359.6 395.8 400z" />
  </svg>
);

export const PrintIcon: FC<IconProps> = ({ size = 1, className }) => (
  <svg
    className={className}
    style={{ display: 'inline-block', verticalAlign: `-${size / 8}em` }}
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}em`}
    viewBox="0 0 512 512"
    fill="currentColor"
  >
    <path d="M128 0C92.7 0 64 28.7 64 64v96h64V64H354.7L384 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L400 18.7C388 6.7 371.7 0 354.7 0H128zM384 352v32 64H128V384 368 352H384zm64 32h32c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v96c0 17.7 14.3 32 32 32H64v64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V384zM432 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" />
  </svg>
);

export const ExpandIcon: FC<IconProps> = ({ size = 1, className }) => (
  <svg
    className={className}
    style={{ display: 'inline-block', verticalAlign: `-${size / 8}em` }}
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}em`}
    viewBox="0 0 448 512"
    fill="currentColor"
  >
    <path d="M32 32C14.3 32 0 46.3 0 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V96h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V352zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32H320zM448 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V352z" />
  </svg>
);

export const ExpandArrowsIcon: FC<IconProps> = ({ size = 1, className }) => (
  <svg
    className={className}
    style={{ display: 'inline-block', verticalAlign: `-${size / 8}em` }}
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}em`}
    viewBox="0 0 512 512"
    fill="currentColor"
  >
    <path d="M344 0H488c13.3 0 24 10.7 24 24V168c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-87 87c-9.4 9.4-24.6 9.4-33.9 0l-32-32c-9.4-9.4-9.4-24.6 0-33.9l87-87L327 41c-6.9-6.9-8.9-17.2-5.2-26.2S334.3 0 344 0zM168 512H24c-13.3 0-24-10.7-24-24V344c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39 87-87c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8z" />
  </svg>
);

export const CompressArrowsIcon: FC<IconProps> = ({ size = 1, className }) => (
  <svg
    className={className}
    style={{ display: 'inline-block', verticalAlign: `-${size / 8}em` }}
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}em`}
    viewBox="0 0 512 512"
    fill="currentColor"
  >
    <path d="M439 7c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H296c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39L439 7zM72 272H216c13.3 0 24 10.7 24 24V440c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39L73 505c-9.4 9.4-24.6 9.4-33.9 0L7 473c-9.4-9.4-9.4-24.6 0-33.9l87-87L55 313c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8z" />
  </svg>
);

export const ShuffleIcon: FC<IconProps> = ({ size = 1, className }) => (
  <svg
    className={className}
    style={{ display: 'inline-block', verticalAlign: `-${size / 8}em` }}
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}em`}
    viewBox="0 0 512 512"
    fill="currentColor"
  >
    <path d="M403.8 34.4c12-5 25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V160H352c-10.1 0-19.6 4.7-25.6 12.8L284 229.3 244 176l31.2-41.6C293.3 110.2 321.8 96 352 96h32V64c0-12.9 7.8-24.6 19.8-29.6zM164 282.7L204 336l-31.2 41.6C154.7 401.8 126.2 416 96 416H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96c10.1 0 19.6-4.7 25.6-12.8L164 282.7zm274.6 188c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V416H352c-30.2 0-58.7-14.2-76.8-38.4L121.6 172.8c-6-8.1-15.5-12.8-25.6-12.8H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96c30.2 0 58.7 14.2 76.8 38.4L326.4 339.2c6 8.1 15.5 12.8 25.6 12.8h32V320c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64z" />
  </svg>
);

export const DiceIcon: FC<IconProps> = ({ size = 1, className }) => (
  <svg
    className={className}
    style={{ display: 'inline-block', verticalAlign: `-${size / 8}em` }}
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}em`}
    viewBox="0 0 640 512"
    fill="currentColor"
  >
    <path d="M274.9 34.3c-28.1-28.1-73.7-28.1-101.8 0L34.3 173.1c-28.1 28.1-28.1 73.7 0 101.8L173.1 413.7c28.1 28.1 73.7 28.1 101.8 0L413.7 274.9c28.1-28.1 28.1-73.7 0-101.8L274.9 34.3zM200 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM96 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 376a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM352 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 120a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm96 328c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H461.7c11.6 36 3.1 77-25.4 105.5L320 413.8V448zM480 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" />
  </svg>
);

export const EraserIcon: FC<IconProps> = ({ size = 1, className }) => (
  <svg
    className={className}
    style={{ display: 'inline-block', verticalAlign: `-${size / 8}em` }}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
    height={`${size}em`}
    fill="currentColor"
  >
    <path d="M290.7 57.4L57.4 290.7c-25 25-25 65.5 0 90.5l80 80c12 12 28.3 18.7 45.3 18.7H288h9.4H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H387.9L518.6 285.3c25-25 25-65.5 0-90.5L381.3 57.4c-25-25-65.5-25-90.5 0zM297.4 416H288l-105.4 0-80-80L227.3 211.3 364.7 348.7 297.4 416z" />
  </svg>
);

export const WheelIcon: FC<IconProps> = ({ size = 1, className }) => (
  <svg
    className={className}
    style={{
      display: 'inline-block',
      verticalAlign: `-${size / 8}em`,
    }}
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}em`}
    viewBox="0 0 512 512"
    fill="currentColor"
  >
    <path d="M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437zM369.1 75A48 48 0 1 0 437 142.9 48 48 0 1 0 369.1 75z" />
  </svg>
);
